import React from 'react';
import { Control } from 'react-hook-form';
import { isAfter } from 'date-fns';

import { cn } from '@/lib/utils';
import { FormField } from '@/components/ui/form';
import InlineInput from '@/components/InlineInput';
import TimePicker from '@/components/TimePicker';
import WeekToggle from '@/components/WeekToggle';
import CompanySelector from '@/components/QuerySelectors/CompanySelector';
import FleetSelector from '@/components/QuerySelectors/FleetSelector';
import ChecklistSelector from '@/components/QuerySelectors/ChecklistSelector';
import UserSelector from '@/components/QuerySelectors/UserSelector';

import { IBuslineSchema } from './schema';
export * from './schema';

interface IProps {
  className?: string;
  control: Control<IBuslineSchema>;
  isLoading: boolean;
}

const BuslineForm: React.FC<IProps> = ({ control, isLoading, className }) => (
  <div className={cn('grid gap-4 py-4', className)}>
    <FormField
      control={control}
      name="company"
      render={({ field }) => (
        <InlineInput
          title="Empresa"
          // disabled={isLoading}
          as={CompanySelector}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
    <FormField
      control={control}
      name="name"
      render={({ field }) => (
        <InlineInput
          title="Nome"
          disabled={isLoading}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
    <FormField
      control={control}
      name="code"
      render={({ field }) => (
        <InlineInput
          title="Código"
          disabled={isLoading}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
    <FormField
      control={control}
      name="fleet"
      render={({ field }) => (
        <InlineInput
          title="Prefixo"
          // disabled={isLoading}
          as={FleetSelector}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />

    <FormField
      control={control}
      name="driver"
      render={({ field }) => (
        <InlineInput
          title="Motorista"
          as={UserSelector}
          value={field.value}
          onChange={field.onChange}
          status={['ACTIVE', 'INVITE']}
          rules={[{ subject: 'actings', action: 'create' }]}
        />
      )}
    />

    <FormField
      control={control}
      name="checkList"
      render={({ field }) => (
        <InlineInput
          title="Checklist"
          // disabled={isLoading}
          as={ChecklistSelector}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
    <FormField
      control={control}
      name="startAt"
      render={({ field: startAtField }) => (
        <>
          <InlineInput
            title="Hora de Início"
            disabled={isLoading}
            as={TimePicker}
            date={startAtField.value}
            setDate={startAtField.onChange}
            hideLabel
          />
          <FormField
            control={control}
            name="endAt"
            render={({ field: endAtField }) => (
              <InlineInput
                title="Hora de Fim"
                disabled={isLoading}
                as={TimePicker}
                date={endAtField.value}
                setDate={endAtField.onChange}
                hideLabel
                helpText={
                  isAfter(startAtField.value, endAtField.value)
                    ? 'A hora de início é maior que a hora de fim, isso significa que a linha começa em um dia e termina no outro.'
                    : undefined
                }
              />
            )}
          />
        </>
      )}
    />

    <FormField
      control={control}
      name="daysOfWeek"
      render={({ field }) => (
        <InlineInput
          title=""
          disabled={isLoading}
          as={WeekToggle}
          className="flex-wrap justify-start"
          type="multiple"
          value={field.value}
          onValueChange={field.onChange}
        />
      )}
    />
  </div>
);

export default BuslineForm;
